<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          label="Полное наименование в соответствии с учредительными документами"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <AddressStructuredField
          @change="v.address.$model = $event"
          :value="v.address.$model"
          :v="v.address"
          label="Адрес (место нахождения) организации"
        />
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          label="ИНН"
          outlined
          disabled
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators';

import {
  getValidationErrorText,
  EMOJI,
  EMAIL,
  MAX_LENGTH_EMAIL,
  INN_ROD,
} from '@/utils/validate';
import AddressStructuredField, {
  addressValidate,
} from '@/components/base/AddressStructuredField';

export const foreignOrganizationFieldsModel = {
  name: '',
  address: {},
  inn: '',
  email: '',
};

export const foreignOrganizationFieldsValidation = {
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  address: {
    required,
    ...addressValidate(),
  },
  inn: {
    required,
    minLength: maxLength(50),
    INN: INN_ROD,
  },
  email: {
    required,
    EMAIL,
    maxLength: maxLength(MAX_LENGTH_EMAIL),
  },
};

export default {
  name: 'ForeignOrganizationFields',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    AddressStructuredField,
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
